module.exports = __webpack_public_path__ + "static/media/settings.10e17192.png";